export default "/assets/images/app-update-img-04.1dbb6d1986056ba8.png";